import _mapValues from "lodash/mapValues";
import _pick from "lodash/pick";
import guardsForModel from "./templateType/forTBuilderModel";

type SchemaKey = keyof typeof guardsForModel;
type GroupsBase<CompleteUnion> = { [K in SchemaKey]: CompleteUnion };

const allSchemaKeys = Object.keys(guardsForModel);

const makeGuardsForModelSubset = <
  CompleteUnion, // Union pro uplne vsechny TBuilder typy
  ApplicableKeys extends SchemaKey,
  Groups extends Record<ApplicableKeys, CompleteUnion> // Slovnik jednotlivych skupin
>(
  criteriaFn: <Key extends ApplicableKeys>(
    key: Key,
    modelSubset: CompleteUnion
  ) => modelSubset is Groups[Key],
  // Kdyz mam kriterium, ktere umi posoudit jen nektere z guardů
  applicableKeys: ApplicableKeys[] = allSchemaKeys as ApplicableKeys[]
) => {
  // Bohužel je nutné typ explicitně konstruovat a pak assertovat, není možné odvodit
  type Guards = {
    [Key in ApplicableKeys]: (member: CompleteUnion) => member is Groups[Key];
  };

  const untypedGuards = _mapValues(
    _pick(guardsForModel, applicableKeys), // I <3 PRETTIER
    (val, key) => criteriaFn.bind(null, key as ApplicableKeys)
  );

  return untypedGuards as unknown as Guards;
};

export default makeGuardsForModelSubset;
